import { Component, OnInit, Input } from '@angular/core'
import { IMaintenanceScreen, DefaultMaintenanceScreen } from '../../models/AppUpdateConfig'

@Component({
  selector: 'app-mantenimiento-screan',
  templateUrl: './mantenimiento-screan.page.html',
  styleUrls: ['./mantenimiento-screan.page.scss'],
})
export class MantenimientoScreanPage implements OnInit {

  @Input() remoteConfigValues: IMaintenanceScreen = DefaultMaintenanceScreen

  constructor() { }

  ngOnInit() {
  }

}
